export default "__VITE_ASSET__BLry7biR__"